import {VehicleHistory} from "../../../libs/enum/vehicle-history";
import {isDefined, isUuid} from "../../../libs/utils/epic.utils";

export class VehicleHistoryDto {

  public id!: string;
  public type!: VehicleHistory;
  public /* readonly */ recorded!: Date;
  public odometer!: number;
  public notes: string | undefined;
  public readonly invoiceId: string | undefined;
  public readonly vehicleId!: string;

  constructor(init?: Partial<VehicleHistoryDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.recorded)) {
      this.recorded = new Date(init.recorded);
    }
  }

  public isEditable(): boolean {
    return !this.hasInvoiceId() && this.type !== VehicleHistory.RECOMMENDED_REPAIR;
  }

  public hasInvoiceId(): boolean {
    return isUuid(this.invoiceId);
  }
}
